import { Injectable } from '@angular/core';
import { Breadcrumb } from '../models/breadcrumb';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Injectable()

/**
 * BreadcrumbService contains methods used for managing the breadcrumb component
 */
export class BreadcrumbService
{
	breadcrumbs: Breadcrumb[];
	translations;

	/**
	 * BreadcrumbService constructor
	 *
	 * @param {Router} router
	 * @param {ActivatedRoute} route
	 */
	constructor(private router: Router, private route: ActivatedRoute)
	{
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.breadcrumbs = this.getRouteBreadcrumbs(this.route);
			}
		});

		this.translations = {};
	}

	/**
	 * Adds a translation for the given breadcrumb that will be used instead of the default label
	 *
	 * @param {string} key
	 * @param {string} value
	 */
	public addBreadcrumbTranslation(key: string, value: string)
	{
		this.translations[key] = value;
	}

	/**
	 * Returns a collection of the given routes' breadcrumbs
	 *
	 * @param {ActivatedRoute} route
	 * @param {string} url
	 * @param {Breadcrumb[]} breadcrumbs
	 * @returns {any}
	 */
	private getRouteBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: Breadcrumb[] = [])
	{
		if (route.snapshot.url.length > 0) {
			url += route.snapshot.url.map(segment => segment.path).join('/') + '/';
		}

		if (route.snapshot.routeConfig && route.snapshot.routeConfig.data && route.snapshot.routeConfig.data.hasOwnProperty('breadcrumb')) {
			breadcrumbs.push(new Breadcrumb(
				route.snapshot.data['breadcrumb'],
				route.snapshot.params,
				url
			));
		}

		if (route.firstChild) {
			return this.getRouteBreadcrumbs(route.firstChild, url, breadcrumbs);
		}

		return breadcrumbs;
	}
}



// WEBPACK FOOTER //
// ./src/app/breadcrumb/breadcrumb.service.ts